import { createRouter, createWebHistory } from 'vue-router'


import store from "@/store";

const routes = [
  {
    path: '/',
    redirect: '/sign-in',
    meta: {
      title: 'หน้าหลัก'
    }
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    component: () => import('../views/SignIn/Index.vue'),
    beforeEnter: (to, from, next) => {
      if (store.getters.authenticated) {
        if(store.getters.profile.roles.includes('superadmin') || store.getters.profile.roles.includes('owner')){
          return next({
            name: 'Dashboard'
          })
        }else if (store.getters.profile.roles.includes('employee') || store.getters.profile.roles.includes('admin')) {
          return next({
            name: 'EmployeeAllLesson'
          })
        }
      }

      next()
    },
    meta: {
      title: 'เข้าสู่ระบบ'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard/Index.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      if (store?.getters?.profile?.roles?.includes('employee')) {
        return next({
          name: 'EmployeeInfo'
        })
      }else if(store?.getters?.profile?.roles?.includes('admin')){
        return next({
          name: 'EmployeeInfo'
        })
      }

      next()
    },
    meta: {
      title: 'แผงควบคุม'
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/Profile/Index.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'ข้อมูลส่วนตัว'
    }
  },
  {
    path: '/user',
    name: 'User',
    component: () => import('../views/User/Index.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'ผู้ใช้งาน'
    }
  },
  {
    path: '/user/add',
    name: 'AddUser',
    component: () => import('../views/User/Add.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'เพิ่มผู้ใช้งาน'
    }
  },
  {
    path: '/user/edit/:id',
    name: 'EditUser',
    component: () => import('../views/User/Edit.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'แก้ไขผู้ใช้งาน'
    }
  },
  {
    path: '/partner',
    name: 'Partner',
    component: () => import('../views/Partner/Index.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'พาร์ทเนอร์'
    }
  },
  {
    path: '/partner/add',
    name: 'AddPartner',
    component: () => import('../views/Partner/Add.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'เพิ่ม พาร์ทเนอร์'
    }
  },
  {
    path: '/partner/edit/:id',
    name: 'EditPartner',
    component: () => import('../views/Partner/Edit.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'แก้ไข พาร์ทเนอร์'
    }
  },
  {
    path: '/lesson',
    name: 'Lesson',
    component: () => import('../views/Lesson/Index.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'บทเรียน'
    }
  },
  {
    path: '/lesson/add',
    name: 'AddLesson',
    component: () => import('../views/Lesson/Add.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'เพิ่ม บทเรียน'
    }
  },
  {
    path: '/lesson/edit/:id',
    name: 'EditLesson',
    component: () => import('../views/Lesson/Edit.vue'),
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'แก้ไขบทเรียน'
    }
  },
  {
    path: '/lesson/:id/quiz',
    name: 'Quiz',
    props: true,
    component: () => import('../views/Lesson/Quiz/Index.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'เพิ่มคำถาม'
    }
  },
  {
    path: '/info',
    name: 'EmployeeInfo',
    component: () => import('../views/Employee/Info/Index.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.authenticated) {
        return next({
          name: 'SignIn'
        })
      }
      next()
    },
    meta: {
      title: 'ข้อมูลส่วนตัว'
    }
  },
  {
    path: '/all-lesson',
    name: 'EmployeeAllLesson',
    component: () => import('../views/Employee/Lesson/Index.vue'),
    meta: {
      title: 'บทเรียน',
      EmployeeAuth: true
    }
  },
  {
    path: '/lessons/:slug',
    name: 'EmployeeLesson',
    props: true,
    component: () => import('../views/Employee/Lesson/Detail.vue'),
    beforeEnter: (to, from, next) => {
      if(store.getters.profile.roles.includes('superadmin')){
        return next({
          name: 'Lesson'
        })
      }
      next()
    },
    meta: {
      title: 'บทเรียน',
      EmployeeAuth: true
    }
  },
  {
    path: '/lesson/:slug/quizzes',
    name: 'EmployeeLessonQuiz',
    props: true,
    component: () => import('../views/Employee/Lesson/Quiz/Index.vue'),
    meta: {
      title: 'แบบทดสอบ',
      EmployeeAuth: true
    }
  },

  
  {
    path: '/owner',
    name: 'OwnerEmployee',
    props: true,
    component: () => import('../views/Owner/Employee/Index.vue'),
    meta: {
      title: 'จัดการพนักงาน',
      EmployeeAuth: true
    }
  },
  {
    path: '/simple-lesson',
    name: 'OwnerLesson',
    component: () => import('../views/Owner/Simple/Index.vue'),
    beforeEnter: (to, from, next) => {
      // if(!store.getters.profile.roles.includes('owner')){
      //   return next({
      //     name: 'Lesson'
      //   })
      // }
      next()
    },
    meta: {
      title: 'บทเรียน'
    }
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: () => import('../views/FAQ/Index.vue'),
    meta: {
      title: 'ปัญหาที่พบบ่อย',
      SuperAuth: true
    }
  },
  
  {
    path: '/setting/category',
    name: 'SettingCategory',
    component: () => import('../views/Setting/Category/Index.vue'),
    beforeEnter: (to, from, next) => {
      if(store.getters.profile.roles.includes('superadmin')){
        next()
      }
      return next({
        name: 'Profile'
      })
    },
    meta: {
      title: 'หมวดหมู่',
      SuperAuth: true
    }
  },
  {
    path: '/setting/department',
    name: 'SettingDepartment',
    component: () => import('../views/Setting/Department/Index.vue'),
    beforeEnter: (to, from, next) => {
      if(store.getters.profile.roles.includes('superadmin')){
        next()
      }
      return next({
        name: 'Profile'
      })
    },
    meta: {
      title: 'ตำแหน่ง',
      SuperAuth: true
    }
  },
  {
    path: '/setting/faq',
    name: 'SettingFAQ',
    component: () => import('../views/Setting/FAQ/Index.vue'),
    beforeEnter: (to, from, next) => {
      if(store.getters.profile.roles.includes('superadmin')){
        next()
      }
      return next({
        name: 'Profile'
      })
    },
    meta: {
      title: 'ปัญหาที่พบบ่อย',
      SuperAuth: true
    }
  },
  {
    path: '/assessment',
    name: 'Assessment',
    component: () => import('../views/Assessment/Index.vue'),
    beforeEnter: (to, from, next) => {
      if(store.getters.profile.roles.includes('superadmin')){
        next()
      }
      return next({
        name: 'Profile'
      })
    },
    meta: {
      title: 'ปัญหาที่พบบ่อย',
      SuperAuth: true
    }
  },
  {
    path: '/setting/reset-user',
    name: 'ResetUser',
    component: () => import('../views/Setting/ResetUser/Index.vue'),
    beforeEnter: (to, from, next) => {
      if(store.getters.profile.roles.includes('superadmin')){
        next()
      }
      return next({
        name: 'Profile'
      })
    },
    meta: {
      title: 'รีเซ็ท ผู้ใช้งาน',
      SuperAuth: true
    }
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: () => import('../views/Maintenance/Index.vue'),
    meta: {
      title: 'กำลังปรับปรุงระบบ'
    }
  },
  
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = `EvolutionSkin | ${to.meta.title}`
  next()
})

export default router
